<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col-md-12">
                  <pr-input-column
                    label=" Combien de parts souhaitez-vous souscrire ?"
                    [derrors]="derrors"
                  >
                    <input
                      notdot
                      formControlName="gfvNbParts"
                      type="number"
                      placeholder="Exemple : 10"
                    />
                  </pr-input-column>
                  <pr-color-panel
                    [display]="investmentAmount?.display"
                    class="margin-panel"
                  >
                    <pr-panel-body clazz="pam">
                      <pr-label
                        [name]="investmentAmount?.icon"
                        [width]="18"
                        [height]="18"
                        >{{ investmentAmount?.text }}</pr-label
                      >
                    </pr-panel-body>
                  </pr-color-panel>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
